export enum EPrayerMeetingStatus {
  DRAFT = 'draft',
  PENDING_VALIDATION = 'pending-validation',
  VALIDATED = 'validated',
  REFUSED = 'refused',
  DELETED = 'deleted',
}
